import Register from "../components/Reports/Register";
import {PERM} from "../utilites/permissions";

const registers = [
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {requiresAuth: true,
      permissions: [
        PERM.REGISTER,
      ]
    },
  },
];

export default registers;



// WEBPACK FOOTER //
// ./src/router/register.js